export const stringTruncate = (text: string, limit: number) => {
  if (!text || text === 'null') return '';
  let str = text;
  if (text.length > limit) {
    str = `${str.substring(0, limit)}...`;
  }
  return str;
};
